<template>
  <div class="big">
    <div class="page_title">诊所列表</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div>
          <div class="box">
            <div class="searchbox">
              <div>
                <span>诊所名称</span>
                <el-input
                  v-model="hospital_name"
                  style="width: 160px; margin: 0 20px 0 10px"
                  @input="search"
                  clearable
                ></el-input>
                <span>诊所类型</span>
                <el-select
                  v-model="org_type"
                  placeholder="请选择"
                  style="width: 160px; margin: 0 20px 0 10px"
                  @change="search"
                >
                  <el-option
                    label="全部"
                    :value="0"
                  ></el-option>

                  <el-option
                    v-for="item in org_type_list"
                    :key="item.org_type"
                    :label="item.org_type_name"
                    :value="item.org_type"
                  ></el-option>
                </el-select>
                <span>提交时间</span>
                <el-date-picker
                  v-model="date"
                  type="daterange"
                  range-separator="~"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  style="width: 264px; margin: 0 12px"
                  @change="
                    (value) => {
                      return search(value, 1);
                    }
                  "
                ></el-date-picker>

                <el-button
                  type="info"
                  style="background-color: #eceff2; color: #747981"
                  @click="search"
                >查询</el-button>
                <span style="margin: 0 10px 0 15px">是否测试</span>
                <el-radio-group
                  v-model="is_test"
                  @change="search"
                >
                  <el-radio :label="0">全部</el-radio>
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="2">否</el-radio>
                </el-radio-group>
              </div>
              <el-button
                type="primary"
                @click="addClinic"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('246') : false
                "
              >添加诊所</el-button>
            </div>

            <div style="border: solid 1px #c9cbd6">
              <el-table
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%; min-width: 1000px"
                :header-cell-style="{ background: '#F5F5F5' }"
              >
                <el-table-column
                  label="诊所名称"
                  prop="hospital_name"
                ></el-table-column>
                <el-table-column
                  label="诊所类型"
                  prop="org_type"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.org_type == 1">综合医院</span>
                    <span v-if="scope.row.org_type == 2">专科医院</span>
                    <span v-if="scope.row.org_type == 3">街道卫生服务中心</span>
                    <span v-if="scope.row.org_type == 4">社区卫生服务中心</span>
                    <span v-if="scope.row.org_type == 5">乡镇卫生院</span>
                    <span v-if="scope.row.org_type == 6">村卫生室</span>
                    <span v-if="scope.row.org_type == 7">企业医院</span>
                    <span v-if="scope.row.org_type == 8">门诊部</span>
                    <span v-if="scope.row.org_type == 9">个体诊所</span>
                    <span v-if="scope.row.org_type == 10">其他</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="纳税人识别号"
                  prop="identification_number"
                ></el-table-column>
                <el-table-column
                  label="法人姓名"
                  prop="real_name"
                ></el-table-column>
                <el-table-column
                  label="联系人手机号"
                  prop="user_phone"
                ></el-table-column>
                <el-table-column
                  label="所在地区"
                  prop="address"
                ></el-table-column>

                <el-table-column
                  label="提交日期"
                  prop="create_time"
                ></el-table-column>
                <el-table-column label="状态">
                  <template slot-scope="scope">
                    <span v-if="scope.row.status">正常</span>
                    <span
                      style="color: #f24b2f"
                      v-else
                    >锁定</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="操作"
                  width="260"
                >
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      @click="toDetail(scope.row.hospital_id)"
                      :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('245')
                          : false
                      "
                    >查看详情</el-button>
                    <el-button
                      type="text"
                      @click="editClinic(scope.row.hospital_id)"
                      :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('246')
                          : false
                      "
                    >编辑</el-button>
                    <el-button
                      type="text"
                      v-if="scope.row.status"
                      @click="updateStatus(scope.row.hospital_id, 1)"
                      :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('247')
                          : false
                      "
                    >锁定</el-button>
                    <el-button
                      type="text"
                      v-if="!scope.row.status"
                      @click="updateStatus(scope.row.hospital_id, 2)"
                      :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('247')
                          : false
                      "
                    >解锁</el-button>
                    <span style="margin-left: 10px; color: #669961">
                      测试
                      <el-switch
                        v-model="scope.row.is_test"
                        active-color="#669961"
                        @change="
                          (value) => {
                            return setTest(value, scope.row.hospital_id);
                          }
                        "
                      ></el-switch>
                    </span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div>
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="10"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum"
                style="margin:20px 0"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 添加诊所弹窗 -->
    <el-dialog
      :title="title"
      :visible.sync="dialogadd"
      width="600px"
      style="text-align: left"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="150px"
        class="demo-ruleForm myform"
      >
        <el-form-item
          label="机构名称"
          prop="hospital_name"
        >
          <el-input
            v-model="ruleForm.hospital_name"
            style="width: 300px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="简称"
          prop="abbreviation"
        >
          <el-input
            v-model="ruleForm.abbreviation"
            style="width: 300px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="纳税人识别号"
          prop="identification_number"
        >
          <el-input
            v-model="ruleForm.identification_number"
            style="width: 300px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="诊所类型"
          prop="org_type"
        >
          <el-select
            v-model="ruleForm.org_type"
            placeholder="请选择"
            style="width: 300px"
          >
            <el-option
              v-for="item in org_type_list"
              :key="item.org_type"
              :label="item.org_type_name"
              :value="item.org_type"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="所在地区"
          prop="district"
        >
          <el-cascader
            v-model="ruleForm.district"
            :options="goodsTypeData"
            placeholder="选择项目位置"
            :props="goodsTypeSet"
            style="width: 300px"
          ></el-cascader>
        </el-form-item>
        <el-form-item
          label="法人姓名"
          prop="real_name"
        >
          <el-input
            v-model="ruleForm.real_name"
            style="width: 300px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="联系人手机号"
          prop="user_phone"
        >
          <el-input
            v-model="ruleForm.user_phone"
            style="width: 300px"
            :disabled="title == '编辑诊所'"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="医疗机构执业许可证"
          prop="business_license"
        >
          <div class="imgbox">
            <el-upload
              class="avatar-uploader"
              name="image"
              :action="uploadUrl"
              :data="uploadExtraData"
              :headers="uploadHeaders"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
              accept=".png,.jpeg,.jpg"
            >
              <img
                v-if="business_license"
                :src="business_license"
                class="avatar"
              />

              <i
                v-else
                class="el-icon-plus avatar-uploader-icon"
              ></i>
            </el-upload>
          </div>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogadd = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import clinic from '../../../api/clinic';
import platform from '../../../api/platform';
import dayjs from 'dayjs';
import constant from '../../../service/common/constant';
import axios from '../../../service/axios/axios';
import _ from 'lodash';
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      org_type_list: [],
      hospital_name: '',
      org_type: 0,
      is_test: 0,
      date: [],
      detail: {},
      dialogadd: false,
      title: '添加诊所',
      goodsTypeData: [],
      goodsTypeSet: {
        value: 'value',
        label: 'label',
        children: 'children'
      },
      ruleForm: {
        hospital_id: 0,
        hospital_name: '',
        abbreviation: '',
        identification_number: '',
        org_type: '',
        province_id: '',
        city_id: '',
        district_id: '',
        real_name: '',
        user_phone: '',
        business_license: '',
        district: []
      },
      business_license: '',
      rules: {
        hospital_name: [
          { required: true, message: '请输入机构名称', trigger: 'blur' },
          { min: 1, max: 30, message: '不超过30个字符', trigger: 'blur' }
        ],
        abbreviation: [
          { required: true, message: '请输入机构简称', trigger: 'blur' },
          { min: 1, max: 10, message: '不超过10个字符', trigger: 'blur' }
        ],
        identification_number: [
          { required: true, message: '请输入纳税人识别号', trigger: 'blur' }
        ],
        org_type: [
          {
            required: true,
            message: '请选择机构类型',
            trigger: 'blur'
          }
        ],
        district: [
          {
            type: 'array',
            required: true,
            message: '请选择所在地区',
            trigger: 'blur'
          }
        ],
        type: [
          {
            type: 'array',
            required: true,
            message: '请至少选择一个活动性质',
            trigger: 'blur'
          }
        ],
        real_name: [
          { required: true, message: '请输入法人姓名', trigger: 'blur' }
        ],
        user_phone: [
          { required: true, message: '请输入联系人手机号', trigger: 'blur' }
        ],
        business_license: [
          {
            required: true,
            message: '请上传医疗机构执业许可证',
            trigger: 'blur'
          }
        ]
      },
      uploadExtraData: {
        img_type: 2,
        suffix: '.jpg'
      }
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    admin_id() {
      return this.$store.state.login.userInfo.admin_id;
    },
    uploadUrl() {
      if (process.env.NODE_ENV == 'development') {
        // 本地开发使用 api 前缀
        return 'api/platform/upload/uploadFile';
      } else {
        return 'platform/upload/uploadFile';
      }
    },
    uploadHeaders: function () {
      return Object.assign(
        {},
        _.pick(constant.HEADERS, ['version', 'platform', 'appid']),
        {
          timestamp: Date.now(),
          token: this.$store.state.login.headerToken
        }
      );
    }
  },
  methods: {
    //获取配置信息
    getConfig() {
      platform.getConfigList().then((res) => {
        if (res.code == 0) {
          this.org_type_list = res.data.org_type_list_clinic;
        }
      });
    },
    //获取地区信息
    getCityData() {
      platform.getProvinceCityDistrict().then((res) => {
        if (res.code == 0) {
          let tree = res.data.list;
          this.transRegions(tree);
          this.goodsTypeData = tree;
        }
      });
    },
    transRegions(tree) {
      tree.forEach((item) => {
        if (item.city || item.district) {
          item.children = item.city || item.district;
          delete item.city;
          delete item.district;
          this.transRegions(item.children);
        }
        if (item.province_id) {
          item.value = item.province_id;
          delete item.province_id;
        }
        if (item.city_id) {
          item.value = item.city_id;
          delete item.city_id;
        }
        if (item.district_id) {
          item.value = item.district_id;
          delete item.district_id;
        }
        if (item.name) {
          item.label = item.name;
          delete item.name;
        }
      });
    },
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        hospital_name: this.hospital_name,
        org_type: this.org_type,
        is_test: this.is_test
      };
      if (this.date && this.date.length > 0) {
        data.start_time = dayjs(this.date[0]).format('YYYY-MM-DD');
        data.end_time = dayjs(this.date[1]).format('YYYY-MM-DD');
      }
      clinic
        .getClinicList(data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list.map((item) => {
              item.create_time = platform.timestampToDate(item.create_time);
              item.is_test = item.is_test == 1 ? true : false;
              return item;
            });
            this.totalNum = res.data.total;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    search(value, status) {
      if (status) {
        if (!value) {
          this.date = [];
        }
      }
      this.currentPage = 1;
      this.getList();
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },

    //锁定/解锁
    updateStatus(hospital_id, hospital_status) {
      if (hospital_status == 1) {
        this.$confirm('锁定后诊所不可运营，确定操作？', '提示', {
          closeOnClickModal: false,
          distinguishCancelAndClose: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        })
          .then(() => {
            clinic
              .changeClinicStatus({ hospital_id, hospital_status })
              .then((res) => {
                if (res.code == 0) {
                  this.$message.success('诊所状态已经更改!');
                }
                this.getList();
              });
          })
          .catch();
      } else {
        this.$confirm('确定更改诊所状态？', '提示', {
          closeOnClickModal: false,
          distinguishCancelAndClose: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        })
          .then(() => {
            clinic
              .changeClinicStatus({ hospital_id, hospital_status })
              .then((res) => {
                if (res.code == 0) {
                  this.$message.success('诊所状态已经更改!');
                }
                this.getList();
              });
          })
          .catch();
      }
    },
    //设置测试账号
    setTest(value, hospital_id) {
      let text = '';
      let status = '';
      if (value) {
        text = '确定将该账号设置为测试账号？';
        status = 1;
      } else {
        text = '确定取消测试账号？';
        status = 2;
      }

      this.$confirm(text, '提示消息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          clinic.setTestClinic({ hospital_id, status }).then((res) => {
            if (res.code == 0) {
              this.$message.success('设置成功');
              this.getList();
            }
          });
        })
        .catch(() => {
          this.getList();
        });
    },
    //添加
    addClinic() {
      this.dialogadd = true;
      this.business_license = '';
      this.title = '添加诊所';
      this.ruleForm = {
        hospital_id: 0,
        hospital_name: '',
        abbreviation: '',
        identification_number: '',
        org_type: '',
        province_id: '',
        city_id: '',
        district_id: '',
        real_name: '',
        user_phone: '',
        business_license: '',
        district: []
      };
    },
    //编辑诊所
    editClinic(hospital_id) {
      this.title = '编辑诊所';
      clinic.getClinicInfo({ hospital_id }).then((res) => {
        if (res.code == 0) {
          let info = res.data.info;
          this.business_license = this.requestImg(info.business_license_str);
          this.ruleForm = {
            hospital_id: info.hospital_id,
            hospital_name: info.hospital_name,
            abbreviation: info.abbreviation,
            identification_number: info.identification_number,
            org_type: info.org_type,
            province_id: info.province_id,
            city_id: info.city_id,
            district_id: info.district_id,
            real_name: info.real_name,
            user_phone: info.user_phone,
            business_license: info.business_license,
            district: [info.province_id, info.city_id, info.district_id]
          };
        }
      });
      this.dialogadd = true;
    },
    //添加提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleForm.province_id = this.ruleForm.district[0];
          this.ruleForm.city_id = this.ruleForm.district[1];
          this.ruleForm.district_id = this.ruleForm.district[2];
          let data = this.ruleForm;
          if (this.title == '添加诊所') {
            clinic.saveClinicInfo(data).then((res) => {
              if (res.code == 0) {
                this.$message.success('添加成功');
                this.dialogadd = false;
                this.getList();
              }
            });
          } else {
            clinic.saveClinicInfo(data).then((res) => {
              if (res.code == 0) {
                this.$message.success('修改成功');
                this.dialogadd = false;
                this.getList();
              }
            });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //上传成功
    handleAvatarSuccess(res, file, fileList) {
      if (res.code === 0) {
        //半路径
        this.ruleForm.business_license = res.data.pic;
        axios({
          method: 'get',
          url: res.data.path
        }).then((res) => {
          //绝对路径
          this.business_license = res;
        });
      }
    },
    dataURItoFile(dataurl, filename) {
      let arr = dataurl.split(',');
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    beforeAvatarUpload(file) {
      const supportImgTypes = ['image/jpeg', 'image/png', 'image/jpg'];
      const isSupportType = _.indexOf(supportImgTypes, file.type) !== -1;
      if (!isSupportType) {
        this.$message.error('上传图片只能是 jpg, png, jpeg 格式!');
        return false;
      }
      const suffix = file.name.substring(file.name.lastIndexOf('.'));
      this.uploadExtraData.suffix = suffix;
      this.uploadHeaders.timestamp = Date.now();
      const _this = this;
      return new Promise((resolve) => {
        const reader = new FileReader();
        const image = new Image();
        image.onload = (imageEvent) => {
          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d');
          const width = 750;
          const height = (750 / image.width) * image.height;
          canvas.width = width;
          canvas.height = height;
          context.clearRect(0, 0, width, height);
          context.drawImage(image, 0, 0, width, height);
          const dataUrl = canvas.toDataURL(file.type);
          const blobData = _this.dataURItoFile(dataUrl, file.name);
          resolve(blobData);
        };
        reader.onload = (e) => {
          image.src = e.target.result;
        };
        reader.readAsDataURL(file);
      });
    },

    //诊所详情
    toDetail(hospital_id) {
      this.$router.push({ path: 'clinicDetail', query: { hospital_id } });
    },
    // 获取图片
    requestImg(src) {
      let value = this.getUrlParam('resources_id', src);
      this.axios
        .get('doctor/cms/getImg', {
          params: { resources_id: value }
        })
        .then((res) => {
          this.business_license = res;
        });
    },
    getUrlParam(key, url) {
      var reg = new RegExp('(^|\\?|&)' + key + '=([^&]*)(\\s|&|$)', 'i');
      if (reg.test(url)) return unescape(RegExp.$2.replace(/\+/g, ' '));
      return '';
    }
  },
  created() {
    this.getConfig();
    this.getCityData();
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}

.box {
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  .searchbox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
}

.imgbox {
  width: 200px;
  height: 144px;
  padding: 10px;
  box-sizing: border-box;
  background-color: #fff;
  border: solid 1px #d6d6d6;
}
.avatar-uploader .el-upload {
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-icon {
  font-size: 32px;
  color: #8c939d;
  font-weight: 600;
  width: 178px;
  height: 124px;
  line-height: 124px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 124px;
  display: block;
}
.myform {
  padding: 20px 30px 0;
  margin-bottom: 100px;
}
.infobox {
  padding: 20px;
  box-sizing: border-box;
  font-size: 16px;
  .infotitle {
    color: #333;
    font-weight: 600;
    width: 150px;
    display: inline-block;
    text-align: right;
    margin-right: 20px;
    margin-bottom: 20px;
  }
  .licensebox {
    display: flex;
    justify-content: flex-start;
  }
  .license {
    width: 390px;
  }
}
</style>
